import { alert } from './modules/alert'

import { loading } from './modules/loading'

import Vue from 'vue'
import Vuex from 'vuex'

import VuexPersistence from 'vuex-persist'

import { Getters, Mutations, Actions, Module, createStore } from 'vuex-smart-module'

import router from '@/router'

import { captcha } from '@/store/modules/captcha'
import { cards } from '@/store/modules/cards'
import { esia } from '@/store/modules/esia'
import { security } from '@/store/modules/security'
import { notifications } from '@/store/modules/notifications'
import { dadata } from '@/store/modules/dadata'
import { claim } from '@/store/modules/claim'
import { support } from '@/store/modules/support'
import { settings, SettingsState } from '@/store/modules/settings'
import { points } from '@/store/modules/points'
import { certificate } from '@/store/modules/certificate'
import { feedback } from '@/store/modules/feedback'

import { ApiError } from '@/api'
import { mock } from '@/tools'

Vue.use(Vuex)

const vuexLocal = new VuexPersistence<State>({
  storage: window.localStorage,
  modules: ['settings'],
  key: 'magadan.cabinet.client',
})

class RootState {}

class RootGetters extends Getters<RootState> {}

class RootMutations extends Mutations<RootState> {}

class RootActions extends Actions<RootState, RootGetters, RootMutations, RootActions> {}

export type State = {
  settings: SettingsState
}

export type RootModules = {
  alert: typeof alert
  cards: typeof cards
  captcha: typeof captcha
  loading: typeof loading
  esia: typeof esia
  security: typeof security
  notifications: typeof notifications
  dadata: typeof dadata
  claim: typeof claim
  settings: typeof settings
  support: typeof support
  points: typeof points
  certificate: typeof certificate
  feedback: typeof feedback
}

export const root = new Module<RootState, RootGetters, RootMutations, RootActions, RootModules>({
  modules: {
    alert,
    captcha,
    cards,
    loading,
    esia,
    security,
    dadata,
    claim,
    settings,
    notifications,
    support,
    certificate,
    points,
    feedback,
  },
  state: RootState,
  getters: RootGetters,
  mutations: RootMutations,
  actions: RootActions,
})

export const store = createStore(root, {
  plugins: [vuexLocal.plugin],
})

store.subscribeAction({
  error: (action, _state, error) => {
    if (error instanceof ApiError) {
      switch (error.status) {
        case 403:
          void router.push({ name: 'login' })
          notifications.context(store).actions.enableCheckNotificationsLoop(false)
          alert.context(store).mutations.openAlert({
            type: 'warning',
            message:
              'Действие недоступно. Повторите вход в личный кабинет для обновления сессии. При повторной ошибке обратитесь в организацию за расширением прав доступа',
          })
          break

        default:
          mock(action, error)
          alert.context(store).mutations.openAlert({ type: 'error', message: error.body.description })
      }
    }
  },
})
